import { BASE_URL } from "../constants";

const ROLE_CACHE_KEY = "irg-last-role";

// True only when the server rejected the session (no token, or a 401: expired, invalid or deactivated).
// Network errors and server hiccups are not a reason to sign anyone out.
export const isSignedOutError = (err) => err?.status === 401 || err?.message === "Token not found";

// The role from the last successful profile check, so pages can open while the server can't be reached.
export const getCachedRole = () => {
  try {
    return localStorage.getItem(ROLE_CACHE_KEY);
  } catch {
    return null;
  }
};

export const getUserProfile = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token not found");

    const res = await fetch(`${BASE_URL}api/users/user/profile`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      const error = new Error("Failed to fetch profile");
      error.status = res.status;
      // The session is gone: forget it, like the axios 401 handler in services/apiService.js.
      if (res.status === 401) localStorage.removeItem("token");
      throw error;
    }

    const data = await res.json();
    try {
      if (data?.role) localStorage.setItem(ROLE_CACHE_KEY, data.role);
    } catch {
      /* only used while offline */
    }
    return data;

  } catch (err) {
    console.error("Error fetching user profile:", err);
    throw err;
  }
};

/**
 * Fetches all user logs with Employee name, Activity, and Timestamp.
 * @returns Array of logs with { name, activity, timestamp }
 */
export const getUserLogs = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token not found");

    const res = await fetch(`${BASE_URL}api/userlogs/logs`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error("Failed to fetch user logs");
    }

    const data = await res.json();

    const formattedLogs = data.map(log => ({
      name: log.User?.Employee?.name || "N/A",
      activity: log.activity,
      timestamp: log.createdAt,
    }));

    return formattedLogs;

  } catch (err) {
    console.error("Error fetching user logs:", err);
    throw err;
  }
};

export const addUserLog = async (activity) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token not found");

    const res = await fetch(`${BASE_URL}api/userlogs/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({ activity }),
    });

    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`Failed to log activity: ${errorText}`);
    }

    const data = await res.json();
    return data;

  } catch (err) {
    console.error("Error adding user log:", err);
    throw err;
  }
};